// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E5w1r","label":"styles_label__1uVQQ"};